import {css} from '@emotion/react'
import ReactMarkdown from 'react-markdown'
import {Prism as SyntaxHighlighter} from 'react-syntax-highlighter'
import {prism} from 'react-syntax-highlighter/dist/esm/styles/prism'
import rehypeRaw from 'rehype-raw'
import remarkGfm from 'remark-gfm'

const cssMarkdownViewer = css({
    overflow: 'auto',

    p: {
        whiteSpace: 'pre-wrap',

        '&:last-child': {
            marginBottom: 0,
        },
    },

    table: {
        margin: '16px 0',
    },

    thead: {
        backgroundColor: '#ececec',
    },

    'td, th': {
        border: '1px solid #ececec',
        padding: 8,
    },

    td: {
        wordBreak: 'break-all',
    },
})

export const MarkdownViewer = ({children, components, ...props}) => {
    const _components = {
        code({children, className, node, ...props}) {
            const match = /language-(\w+)/.exec(className || '')

            if (match) {
                return (
                    <SyntaxHighlighter
                        style={prism}
                        language={match[1]}
                        PreTag="div"
                        wrapLines
                        {...props}
                    >
                        {String(children).replace(/\n$/, '')}
                    </SyntaxHighlighter>
                )
            }
            else {
                return (
                    <code
                        className={className}
                        {...props}
                    >
                        {children}
                    </code>
                )
            }
        },

        ...components,
    }

    return (
        <div
            css={cssMarkdownViewer}
            {...props}
        >
            <ReactMarkdown
                components={_components}
                //rehypePlugins={[rehypeRaw]}
                remarkPlugins={[remarkGfm]}
            >
                {children}
            </ReactMarkdown>
        </div>
    )
}
